module.exports = __webpack_public_path__ + "static/media/rock-2-A1.png";